import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { VersionOptionDto } from '@/api-sdk';
import { baseStyles } from '@/styles';

import './fg-version-option';

@customElement('fg-version-options-list')
export class FgVersionOptionsList extends LitElement {
  @property({ type: String })
  stepTitle = '';

  @property({ type: Array })
  options: VersionOptionDto[] = [];

  render() {
    return html`
      ${this.stepTitle &&
      html`
        <p class="title"><strong>${this.stepTitle}</strong></p>
      `}

      <div class="options-list">
        ${this.options.map(
          option => html`
            <fg-version-option .option=${option}></fg-version-option>
          `,
        )}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .title {
        font-size: 1rem;
      }

      .options-list {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(3, 1fr);
        margin-top: 10px;
      }
    `,
  ];
}
